import React from "react";
import { Box, Typography, Container } from "@mui/material";
import PartnerChat from "../../CommonPage/PartnerChat/PartnerChat";
import ContactForm from "../ConatctForm/ContactForm";
import PartnerForm from "../ConatctForm/PartnerForm";

const PartnerWithUs = () => {
  return (
    <Box>
      {/* Top Banner Section */}
      <Box
        sx={{
          height: { xs: "75vh", md: "100vh" },
          backgroundImage: "url(https://res.cloudinary.com/dk24unkwu/image/upload/v1753695085/fulll_gk23ab.svg)", // You can change this image if you have a partnership-specific one
          backgroundSize: "cover",
          backgroundPosition: "center",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          position: "relative",
          textAlign: "center",
          px: 2,
          zIndex: 1,
        }}
      >
        {/* Optional Overlay */}
        <Box
          sx={{
            position: "absolute",
            inset: 0,
            backgroundColor: "transparent",
          }}
        />

        {/* Content */}
        <Container
          sx={{
            position: "relative",
            zIndex: 2,
          }}
        >
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              flexDirection: "column",
              gap: 2,
            }}
          >
            <Box
              component="img"
              src="/Images/contactLogo.png" // Change to a partnership logo if available
              alt="logo"
              sx={{
                height: { xs: 50, sm: 60, md: 70 },
                width: { xs: 50, sm: 60, md: 70 },
              }}
            />

            <Typography
              variant="h2"
              sx={{
                fontWeight: "bold",
                mt: 4,
                color: "#000",
                fontSize: {
                  xs: "1.75rem",
                  sm: "2.5rem",
                  md: "3rem",
                  lg: "4.5rem",
                },
              }}
            >
              Partner With Us
            </Typography>

            <Typography
              variant="h5"
              sx={{
                maxWidth: 600,
                mt: 3,
                mx: "auto",
                color: "#667085",
                fontSize: {
                  xs: "1rem",
                  sm: "1.25rem",
                  md: "1.8rem",
                },
              }}
            >
              Interested in collaborating
            </Typography>
          </Box>
        </Container>
      </Box>

      {/* Overlapping Cards Section */}
      <Box sx={{ mt: { xs: -10, md: -15 }, position: "relative", zIndex: 3 }}>
        <PartnerForm />
      </Box>
    </Box>
  );
};

export default PartnerWithUs; 